'use strict'

import {
  register
} from '../../services/account-services'
import VueLadda from 'vue-ladda'
// import VueRecaptcha from 'vue-recaptcha'
import Datepicker from 'vuejs-datepicker'
import Password from 'vue-password-strength-meter'
import VuePhoneNumberInput from 'vue-phone-number-input'
// import VueGrecaptcha from 'vue-grecaptcha'
import * as moment from 'moment'

export default {
  components: {
    'vue-ladda': VueLadda,
    // VueRecaptcha,
    Datepicker,
    Password,
    VuePhoneNumberInput,
  },
  data() {
    return {
      formValid: false,
      passwordScore: 0,
      inputTypeLabel: 'Show password',
      selectedInputType: 'password',
      telInputData: {},
      telInputProps: {
        required: true,
        autocomplete: "off",
        enabledCountryCode: false,
        onlyCountries: ['HT', 'DO', 'CA', 'US', 'FR', 'CL', 'BR'],
        placeholder: 'Phone number',
        inputOtions: {
          showDialCode: false
        },
        validCharactersOnly: true
      },
      account: {
        gender: 'not-specified',
        birthDate: '1980-10-20',
        phoneNumber: ''
      },
      control: null,
      form: null,
      doneSignUp: false,
      signUpError: false,
      signUpSuccess: false,
      confirmPassword: '',
      loading: false,
      captchaResponse: '',
    }
  },
  methods: {
    toggleInputType() {
      if (this.selectedInputType !== 'password') {
        this.selectedInputType = 'password'
        this.inputTypeLabel = 'Show password'
      } else {
        this.selectedInputType = 'text'
        this.inputTypeLabel = 'Hide password'
      }
    },
    phoneChanged(data) {
      this.telInputData = data
    },
    isFormValid() {
      let isValid = true
      if (this.account.firstName < 3) isValid = false
      if (this.account.lastName < 3) isValid = false
      if (this.passwordScore < 2) isValid = false
      if (this.confirmPassword !== this.account.password) isValid = false
      if (!this.account.birthDate) isValid = false
      if (!this.telInputData.isValid) isValid = false
      return isValid
    },
    captchaCallback(response) {
      console.log(response)
    },
    captchaExecute(data) {
    },
    previousStep() {
      this.$parent.activeStep--
    },
    signup() {
      this.loading = true
      this.account.countryCode = this.telInputData.countryCode
      this.account.phoneNumber = this.telInputData.formattedNumber.split('+')[1]
      register(this.account).then((result) => {
        this.signUpSuccess = true
        this.doneSignUp = true
        this.loading = false
      }).catch((err) => {
        if (err) this.signUpError = true
        this.loading = false
      })
    },
    login() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = false
      } else {
        this.$router.push('/login')
      }
    },
    goToMerchantSignup() {
      this.$router.push('/merchant/signup')
    },
    showFeedback({suggestions, warning}) {
    },
    showScore(score) {
      this.passwordScore = score
    }
  },
  mounted() {
    // // $('#phone').intlTelInput()
    // let telInput = $('#phone')
    // let errorMsg = $('#error-msg')
    // let validMsg = $('#valid-msg')
    // // $('#phone').intlTelInput()
    // // initialise plugin
    // telInput.intlTelInput({
    //   utilsScript: '../../static/js/phone/utils.js'
    // })
    // const reset = function () {
    //   telInput.removeClass('error')
    //   errorMsg.addClass('hide')
    //   validMsg.addClass('hide')
    // }

    // // on blur: validate
    // telInput.blur(function () {
    //   reset()
    //   if ($.trim(telInput.val())) {
    //     if (telInput.intlTelInput('isValidNumber')) {
    //       validMsg.removeClass('hide')
    //     } else {
    //       telInput.addClass('error')
    //       errorMsg.removeClass('hide')
    //     }
    //   }
    // })
    // // on keyup / change flag: reset
    // telInput.on('keyup change', reset)
  }
}



// WEBPACK FOOTER //
// ./src/components/Signup/Signup.js